import axiosInstance from '@/api/axios.js'
import Pusher from 'pusher-js/dist/web/pusher.min.js'

window.addEventListener('vite:preloadError', (event) => {
    window.location.reload()
})

window.Pusher = Pusher

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axiosInstance
